import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTranscriptionPanelContainerWireframe from '../VeltTranscriptionPanelContainerWireframe/VeltTranscriptionPanelContainerWireframe';
import VeltTranscriptionPanelWireframe from '../VeltTranscriptionPanelWireframe/VeltTranscriptionPanelWireframe';
import VeltTranscriptionButtonWireframe from '../VeltTranscriptionButtonWireframe/VeltTranscriptionButtonWireframe';
import VeltTranscriptionTooltipWireframe from '../VeltTranscriptionTooltipWireframe/VeltTranscriptionTooltipWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltTranscriptionFloatingModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-floating-mode-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionFloatingModeWireframe.Button = VeltTranscriptionButtonWireframe;
VeltTranscriptionFloatingModeWireframe.Tooltip = VeltTranscriptionTooltipWireframe;
VeltTranscriptionFloatingModeWireframe.PanelContainer = VeltTranscriptionPanelContainerWireframe;
VeltTranscriptionFloatingModeWireframe.Panel = VeltTranscriptionPanelWireframe;
export default VeltTranscriptionFloatingModeWireframe;
